import React, { Component } from "react";
import {Badge, Table, Glyphicon, OverlayTrigger} from 'react-bootstrap';
import { ProductService } from "../Services/ProductService";
import { PromotionService } from "../Services/PromotionService";
import {tooltip, getTimeInIST, format_without_time, format, toInt} from '../Utils';
import moment from 'moment';
// import DatePicker from 'react-datepicker';
// import "react-datepicker/dist/react-datepicker.css";
import '../css/promotion.css';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import { RowCountOptions } from "../Config";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { MuiPickersUtilsProvider, DateTimePicker } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';


const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    }, 
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px'
    },
  });

class Promotion extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        current_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        filter: '',
        new_promotion: {code: "", description: "", conditions: new Map(), start_date: moment(), end_date: moment(), priority: 0, promotion_details:  new Map()},
        promotion_details : new Map(),
        promotion_rows: [],
        show: false,
        showPromotionDialog: false,
        promotion_dialog_details: [],
        columns : [
            { id: 'code', numeric: false, disablePadding: false, label: 'Code', sortable: true },
            { id: 'description', numeric: false, disablePadding: false, label: 'Description' , sortable: false },
            { id: 'start_date', numeric: false, disablePadding: false, label: 'Start Date', sortable: true  },
            { id: 'end_date', numeric: false, disablePadding: false, label: 'End Date', sortable: true  },
            { id: 'priority', numeric: true, disablePadding: false, label: 'Priority', sortable: true  },
            { id: 'status', numeric: false, disablePadding: false, label: 'Status', sortable: true  },
            { id: 'conditions', numeric: false, disablePadding: false, label: 'Conditions' , sortable: false },
            { id: 'promotion_details', numeric: false, disablePadding: false, label: 'Promotion Details', sortable: false  },
            { id: 'actions', numeric: false, disablePadding: false, label: 'Actions' , sortable: false },
        ],
        order: 'asc',
        orderBy: 'code',
      }

      this.handleSelect = this.handleSelect.bind(this);
      this.clearSearch = this.clearSearch.bind(this);

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handlePromotionChange = this.handlePromotionChange.bind(this);
      this.addModifyPromotion = this.addModifyPromotion.bind(this);
      this.createModifyPromotion = this.createModifyPromotion.bind(this);
      this.removePromotion = this.removePromotion.bind(this);

      this.showPromotion = this.showPromotion.bind(this);
      this.toggleStatus = this.toggleStatus.bind(this);
      this.handleClosePromotionDialog = this.handleClosePromotionDialog.bind(this);
      this.handleShowPromotionDialog = this.handleShowPromotionDialog.bind(this);
      this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
      this.handleStartDateChange = this.handleStartDateChange.bind(this);
      this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }

    componentWillMount(){
        this.props.isLoading(true);
        PromotionService.getTotalCount()
        .then((data) => {
            console.log(data);
            this.setState({
                totalItems: toInt(data.count), 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
            this.fetchProductList();
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchProductList(){
        ProductService.getProductList()
        .then((data) => {
            console.log(data);
            this.setState({master_products: data.products.filter(p => p.status !== -1)});
            this.fetchData(0, this.state.numItemsPerPage);
        })
        .catch((error) =>{
            console.log("Error while fetching product list");
        })
    }

    toggleStatus(e, promotion){
        e.preventDefault();
        this.props.showConfirmDialog(`Confirm ${promotion.status === "1" ? "Deactivation": "Activation"} of ${promotion.code}?`, undefined, () =>{
            PromotionService.togglePromotionStatus(promotion.id)
            .then((data) => {
                console.log(data);
                const status = data.status === "0" ? "Deactivated": "Activated";
                this.props.showSnackBar(`${status} Promotion ${data.code}`, 'info');
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                if (data.status === "1") {
                    this.addModifyPromotion(null, promotion);
                }
            })
            .catch(error => console.log(error));
            this.props.closeConfirmDialog();
        });
    }

    removePromotion(e, promotion){
        e.preventDefault();
        this.props.showConfirmDialog(`Confirm removal of Promotion: ${promotion.code}?`, undefined, () =>{
            PromotionService.removePromotion(promotion.id)
            .then((data) => {
                if(data.success){
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                } else {
                    this.props.showSnackBar(`Something went wrong. Please try again later.` , 'error'); 
                }
            })
            .catch(error => {
                console.log(error);
            });
            this.props.closeConfirmDialog();
        });
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(start, numberItems, filter = ''){
        this.props.isLoading(true);
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        PromotionService.getPromotionsList(start, numberItems, filter, sort, direction)
        .then((data) => {
            if(data.promotions){
                data.promotions.forEach((promotion) => {
                    this.fetchPromotionDetails(promotion.id);

                    let allConditions = new Map();
                    promotion.conditions.split("|").forEach((c) => {
                        let cc = c.split(':');
                        let v = [];
                        if(allConditions.has(cc[0])){
                            v = allConditions.get(cc[0]);
                        }
                        v.push(cc[1]);
                        allConditions.set(cc[0], v);
                    });
                    promotion.conditions = allConditions;

                    rows.push(<PromotionDetails key={promotion.id} promotion={promotion} showPromotion={this.showPromotion} edit={this.addModifyPromotion} remove={this.removePromotion} toggleStatus={this.toggleStatus}/>);
                });
            }
            this.setState({
                data: data.promotions, originalData: data.promotions, current_rows: rows
            });
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchPromotionDetails(promotion_id){

        PromotionService.getPromotionDetails(promotion_id)
        .then((data) => {
            console.log(data);
            if(data.details.length > 0){
                let promotion_details = this.state.promotion_details;
                let detailsMap = new Map();
                data.details.forEach((detail) => {
                    detailsMap.set(detail.product_id, detail.rate);
                });
                promotion_details.set(promotion_id, detailsMap);
                this.setState({ promotion_details: promotion_details});
            }
            
        })
        .catch(error => {
            console.log(error);
        });
    }

    handleChangeCheckBox(e) {
        let change = this.state.new_promotion;
        if(e.target.checked){
            if(change.conditions.get(e.target.name)){
                let c = change.conditions.get(e.target.name);
                c.push(e.target.id);
            } else {
                change.conditions.set(e.target.name, [e.target.id]);
            }
        } else {
            if(change.conditions.get(e.target.name)){
                let c = change.conditions.get(e.target.name);
                var index = c.indexOf(e.target.id);
                c.splice(index, 1);
            }
        }
        this.setState({new_promotion: change});
    }

    handleChange(e) {
        if(e)
            e.preventDefault();
        let change = this.state.new_promotion;
        change[e.target.name] = e.target.value;
        this.setState({new_promotion: change});
    }

    handleStartDateChange(date) {
        let change = this.state.new_promotion;
        change.start_date = date;
        this.setState({new_promotion: change});
    }

    handleEndDateChange(date) {
        let change = this.state.new_promotion;
        change.end_date = date;
        this.setState({new_promotion: change});
    }

    handlePromotionChange(e){
        let change  = this.state.new_promotion;
        let key = e.target.name;
        let value = parseFloat(e.target.value);
        change.promotion_details.set(key, value);
        
        this.setState({new_promotion: change});
    }

    addModifyPromotion(e, promotion){
        if(e){
            e.preventDefault();
        }
        if(promotion) {
            //Add previous promotion details to state and populate the form
            this.setState({ new_promotion: {id: promotion.id, code: promotion.code, description: promotion.description, conditions: promotion.conditions, start_date: moment(promotion.start_date), end_date: moment(promotion.end_date), priority: promotion.priority, promotion_details: this.state.promotion_details.has(promotion.id) ?  this.state.promotion_details.get(promotion.id):  new Map() }});
        }
        let rows = [];
        this.state.master_products.forEach((element, index) => {
            rows.push(
                <tr key={index}>
                    <td style={{verticalAlign: "middle"}}>{element.name}</td>
                    <td style={{verticalAlign: "middle"}}>{element.unit_price}</td>
                    <td>
                        <TextField
                            id="commission"
                            label="Promotion Price"
                            placeholder="Promotion Price"
                            name={element.id}
                            defaultValue={promotion && promotion.id && this.state.promotion_details.has(promotion.id) ?  this.state.promotion_details.get(promotion.id).get(element.id) : element.unit_price}
                            className={this.props.classes.textField}
                            margin="normal"
                            variant="outlined"
                            onChange={this.handlePromotionChange}
                            InputProps={{
                                inputProps: { min: 0, max:  element.unit_price }
                            }} />
                    </td>
                </tr>
            );
        });
        this.setState({ promotion_rows: rows });
        
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false});
        this.setState({ new_promotion: {code: "", description: "", conditions: new Map(), start_date: moment(), end_date: moment(), priority: 0, promotion_details:  new Map()}});
    }

    handleShowPromotionDialog() {
        this.setState({ showPromotionDialog: true });
    }

    handleClosePromotionDialog() {
        this.setState({ showPromotionDialog: false, promotion_dialog_details : [] });
    }
    
    handleShow() {
        this.setState({ show: true });
    }

    showPromotion(e, promotion){
        e.preventDefault();
        let rows = [];
        if(this.state.promotion_details.has(promotion.id)){
            let pro = this.state.promotion_details.get(promotion.id);
            this.state.master_products.forEach((p)=>{
                rows.push(
                    <tr key={p.id}>
                        <td>{p.name}</td>
                        <td>
                            { pro.get(p.id) ? <strike>{p.unit_price}</strike> : p.unit_price }
                        </td>
                        <td>
                            {pro.get(p.id) ? <span>{pro.get(p.id)}<span style={{marginLeft: "5px", color:  pro.get(p.id) - p.unit_price > 0 ? "green" : "red"}}>({pro.get(p.id) - p.unit_price})</span></span>  : p.unit_price}
                        </td>
                    </tr>
                );
            });
            this.setState({ promotion_dialog_details: rows });
            this.handleShowPromotionDialog();
        } else {
            this.props.showConfirmDialog(`No promotions found`, undefined, undefined);
        }
    }

    confirmSave = () => {
        this.props.isLoading(true); 
        let new_promotion = this.state.new_promotion;
        let conditions = '';
        let len = new_promotion.conditions.get('type').length
        new_promotion.conditions.get('type').forEach((type, index) => {
            conditions += "type:" + type + (index === len - 1? "" : "|") ;
        });
        new_promotion.new_conditions = conditions;
        
        let promotion_details = []
        new_promotion.promotion_details.forEach((value, key, map) => {
            promotion_details.push({ "product_id" : key, "rate" : value});
        });

        new_promotion.new_promotion_details = promotion_details;

        new_promotion.new_start_date = moment(new_promotion.start_date).format(format);
        new_promotion.new_end_date = moment(new_promotion.end_date).format(format);

        PromotionService.createPromotion(new_promotion)
        .then((data) => {
            console.log(data);
            this.props.isLoading(false);
            this.handleClose();
            this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
            this.props.closeConfirmDialog();
        })
        .catch(error => {
            this.props.showSnackBar(`Something went wrong. Please try again later.` , 'error');
            this.props.isLoading(false);
        });
    }

    createModifyPromotion(e){
        e.preventDefault();
        let new_promotion = this.state.new_promotion;
        if(new_promotion.code && new_promotion.description && new_promotion.start_date && new_promotion.end_date && new_promotion.conditions.get('type') && new_promotion.conditions.get('type').length > 0){
            this.props.showConfirmDialog("Create Promotion", "Confirm", this.confirmSave);
        } else {
            this.props.showConfirmDialog("Please fill in all the details", undefined, undefined);
        }
    }

    clearSearch(e){
        this.refs.inputText.value = "";
        this.setState({filter: ''});
        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
    }

    filterCriteria(e){
        e.preventDefault();
            const searchText = this.refs.inputText.value;
            this.setState({filter: searchText}, () => this.fetchData(0, this.state.numItemsPerPage, searchText));
    }
    
    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage){
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }
    
    render() {
        let message = this.state.message;
        return (
            <div className="Home">
                <h3 style={{marginBottom: '20px'}}>Promotions <Badge>{this.state.totalItems}</Badge></h3>
                <br />
                <div>
                    <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                        <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "80%", marginBottom: "10px", marginRight: "10px", padding: "5px", borderColor:"red"}} autoComplete="off">
                        </input>
                        <Glyphicon glyph="remove" onClick={this.clearSearch} style={{marginRight: "20px"}}/>
                    </form>
                </div>
                {/* <Pager>
                    <Pager.Item previous disabled={this.state.currentPageNumber  === 0}  eventKey="prev" onSelect={this.handleSelect} href="#">
                        &larr; Previous Page {this.state.currentPageNumber  === 0 ? "" : this.state.currentPageNumber }
                    </Pager.Item>
                    <Pager.Item next disabled={this.state.currentPageNumber  === this.state.totalPages} eventKey="next" onSelect={this.handleSelect} href="#" >
                        Next Page {this.state.currentPageNumber  === this.state.totalPages ? "": this.state.currentPageNumber + 2} &rarr;
                    </Pager.Item>
                </Pager> */}
                <div className="container">
                    <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    { !message &&
                        <Paper className={this.props.classes.root} style={{width: "100%", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px"}}>
                            <Table striped condensed hover responsive>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows ={this.state.columns} />
                                <TableBody>
                                {this.state.current_rows}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                        </Paper>
                    }
                </div>
                <DialogMUI
                    disableBackdropClick
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">{this.state.new_promotion.code ? "Promotion" : "Create Promotion"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <TextField
                                        id="code"
                                        label="Promotion Code"
                                        placeholder="Promotion Code"
                                        name="code"
                                        defaultValue={this.state.new_promotion.code}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth />
                                <TextField
                                        id="description"
                                        label="Description"
                                        placeholder="Description"
                                        name="description"
                                        defaultValue={this.state.new_promotion.description}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth />
                                <TextField
                                        id="priority"
                                        label="Priority"
                                        placeholder="Priority"
                                        name="priority"
                                        defaultValue={this.state.new_promotion.priority}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end" style={{width: "10%"}}>0 - 99</InputAdornment>,
                                            inputProps: { min: 0, max:99 }
                                        }}
                                        helperText='Incase Two promotions clash, which one superceeds the other is decided by priority. 0 being the lowest and 99 being the highest.'
                                        fullWidth />
                                    <div>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DateTimePicker
                                                margin="normal"
                                                label="Start Date"
                                                value={this.state.new_promotion.start_date}
                                                onChange={this.handleStartDateChange}
                                                format='DD/MM/YY HH:mm a'
                                                style={{height: "100%", marginRight: "20px"}}
                                            />
                                            <DateTimePicker
                                                margin="normal"
                                                label="End Date"
                                                value={this.state.new_promotion.end_date}
                                                onChange={this.handleEndDateChange}
                                                format='DD/MM/YY HH:mm a'
                                                style={{height: "100%"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <FormControlLabel
                                        style={{marginTop: this.state.show ? "20px" : ''}}
                                        control={
                                            <Checkbox
                                                checked={this.state.new_promotion.conditions.has("type") ? this.state.new_promotion.conditions.get("type").includes("CUSTOMER") : false}
                                                onChange={this.handleChangeCheckBox} 
                                                id="CUSTOMER" name="type"
                                                />
                                            }
                                        label="Customers"
                                        />
                                    <FormControlLabel
                                        style={{marginTop: this.state.show ? "20px" : ''}}
                                        control={
                                            <Checkbox
                                                checked={this.state.new_promotion.conditions.has("type") ? this.state.new_promotion.conditions.get("type").includes("STORE") : false}
                                                onChange={this.handleChangeCheckBox} 
                                                id="STORE" name="type"
                                                />
                                            }
                                        label="Stores"
                                        />
                                        <Typography variant="subtitle1" id="modal-title">
                                                Promotion Details
                                        </Typography>
                                        <Divider variant='middle'/>
                                        <Table>
                                            <tbody>
                                                {this.state.promotion_rows}
                                            </tbody>
                                        </Table>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.createModifyPromotion} color="primary" autoFocus>
                                Save
                            </Button>
                        </DialogActions>
                </DialogMUI>
                <DialogMUI
                    disableBackdropClick
                    open={this.state.showPromotionDialog}
                    onClose={this.handleClosePromotionDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">{this.state.showPromotionDialog ? "Promotion Details" : ""}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <Divider />
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Rate</th>
                                            <th>Promotional Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.promotion_dialog_details}
                                    </tbody>
                                </Table>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClosePromotionDialog} color="primary" autoFocus>
                                Close
                            </Button>
                        </DialogActions>
                </DialogMUI>
                <Fab onClick={this.addModifyPromotion} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '90%'}}>
                    <AddIcon />
                </Fab>
            </div>
        );
    }

}

class PromotionDetails extends Component {

    render(){
        const promotion = this.props.promotion;
    //   const format = 'YYYY-MM-DD HH:mm:SS';
    //   const time = moment(location.time, format);

      return (
        <tr className={promotion.status === "1" && moment(promotion.end_date).utc().isSameOrAfter(moment().utc()) ? "success" : "danger" }>
            <td>{promotion.code}</td>
            <td>{promotion.description}</td>
            <td style={{minWidth: "100px"}}>{getTimeInIST(promotion.start_date).format(format_without_time)}</td>
            <td style={{minWidth: "100px"}}>{getTimeInIST(promotion.end_date).format(format_without_time)}</td>
            <td>{promotion.priority}</td>
            <td>{promotion.status === "1" && moment(promotion.end_date).utc().isSameOrAfter(moment().utc()) ? "Active" : "Inactive"}</td>
            <td>{promotion.conditions.get("type").join()}</td>
            <td>
                <Glyphicon glyph="list-alt" onClick={(e) => this.props.showPromotion(e, promotion)}/>
            </td>
            <td>
                <Glyphicon style={{marginRight: "10px"}} glyph="pencil" onClick={(e) => this.props.edit(e, promotion)}/>
                <OverlayTrigger placement="bottom" overlay={tooltip("Remove Promotion")}>
                    <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.remove(e, promotion)}/>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={tooltip("Activate/Deactivate")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="off" onClick={(e) => this.props.toggleStatus(e, promotion)}/>
                </OverlayTrigger>
            </td>
        </tr>
      );
    }
}

export default withStyles(styles)(Promotion);